module.exports = __webpack_public_path__ + "static/media/yiyuan1.b736fa7e.png";